import * as React from 'react';
import { Title3, Body1, makeStyles, tokens, Spinner, Text } from '@fluentui/react-components';
import { useCurrentUser } from '../../contexts/UserContext';

const useStyles = makeStyles({
  container: {
    padding: tokens.spacingHorizontalXL,
  },
  userInfo: {
    marginTop: tokens.spacingVerticalL,
    padding: tokens.spacingHorizontalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
});

export default function Home() {
  const styles = useStyles();
  const { currentUser, loading, error } = useCurrentUser();

  return (
    <div className={styles.container}>
      <Title3 style={{ marginBottom: 16 }}>Bem-vindo à Home!</Title3>
      <Body1>Você está logado.</Body1>

      <div className={styles.userInfo}>
        <Title3 style={{ marginBottom: tokens.spacingVerticalS }}>Informações do Usuário</Title3>

        {loading && (
          <div className={styles.loading}>
            <Spinner size="small" />
            <Text>Carregando informações do usuário...</Text>
          </div>
        )}

        {error && (
          <Text style={{ color: tokens.colorPaletteRedForeground1 }}>
            Erro ao carregar informações: {error}
          </Text>
        )}

        {currentUser && (
          <div>
            <Text><strong>ID do Usuário:</strong> {currentUser.id}</Text>
            <br />
            <Text><strong>Nome/Razão Social:</strong> {currentUser.razaoSocial}</Text>
            <br />
            <Text><strong>E-mail:</strong> {currentUser.email}</Text>
            <br />
            <Text><strong>Tipo:</strong> {currentUser.tipo === 0 ? 'Usuário Individual' : 'Empresa'}</Text>
            <br />
            <Text><strong>Ativo:</strong> {currentUser.ativo ? 'Sim' : 'Não'}</Text>
          </div>
        )}

        {!loading && !error && !currentUser && (
          <Text>Informações do usuário não disponíveis.</Text>
        )}
      </div>
    </div>
  );
}
